import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import Navbar from "./navBar";
import Footer from "./footer";
import { EmployeeAppApiBase } from "./BaseUrl";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [message, setMessage] = useState("");

  const formik = useFormik({
    initialValues: { email: "" },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email address").required("Required"),
    }),
    onSubmit: async (values) => {
      setLoader(true);
      setMessage("");
      try {
        const response = await fetch(`${EmployeeAppApiBase}/send-reset-otp`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: values.email.trim().toLowerCase() }),
        });
        const data = await response.json();

        if (data.success) {
          setMessage(data.msg || "If this email is registered, you will receive an OTP shortly.");
          setTimeout(() => {
            navigate("/reset-password", { state: { email: values.email.trim().toLowerCase() } });
          }, 1500);
        } else {
          setMessage(data.msg || "Something went wrong. Please try again.");
          setLoader(false);
        }
      } catch (error) {
        console.error("ForgotPassword error:", error);
        setMessage("An error occurred. Please try again later.");
        setLoader(false);
      }
    },
  });

  return (
    <>
      <Navbar />
      <div className="border border-green-700"></div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row mb-14 justify-center mt-14 gap-14">
          <div className="lg:w-[400px] mx-auto">
            <div className="font-bold text-center text-2xl text-green-600">
              Forgot Password
            </div>
            <p className="text-center text-slate-600 mt-2 text-sm">
              Enter your registered email and we&apos;ll send you an OTP to reset your password.
            </p>
            <div className="text-red-600 text-center mt-4">{message}</div>
            <form onSubmit={formik.handleSubmit} className="mt-6">
              <input
                type="email"
                placeholder="Email Address"
                className="border-b w-full mt-4 p-2"
                {...formik.getFieldProps("email")}
              />
              {formik.touched.email && formik.errors.email ? (
                <div className="text-red-500 text-sm mt-1">{formik.errors.email}</div>
              ) : null}

              <button
                type="submit"
                disabled={loader}
                className="bg-[#108A00] hover:bg-green-800 p-2 w-full text-white rounded-md text-center mt-10 flex justify-center items-center cursor-pointer disabled:opacity-70"
              >
                {loader ? (
                  <svg
                    className="h-5 w-5 animate-spin"
                    fill="white"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z" />
                  </svg>
                ) : (
                  "Send OTP"
                )}
              </button>
            </form>
            <div className="flex items-center justify-center mt-6 gap-2">
              <span className="text-slate-400">Remember your password?</span>
              <button
                type="button"
                onClick={() => navigate("/login/")}
                className="text-[#108A00] font-medium cursor-pointer"
              >
                Back to Login
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
